/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpLeftIcon20Solid = forwardRef('ArrowShapeAUpLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.25 3A2.25 2.25 0 0 0 3 5.25v10.176c0 1.203 1.454 1.805 2.304.955l2.117-2.117 3.352 3.351a2 2 0 0 0 2.828 0l4.013-4.014a2 2 0 0 0 0-2.828l-3.35-3.351 2.117-2.117c.85-.85.248-2.305-.955-2.305H5.25Z" })));
});
